import React from 'react';

/**
 * Key-Value Lazy Loaded Pages Registry Map
 * Maps dynamic menu identifiers from backend/permissions API to lazy-loaded views.
 */
export const componentRegistry = {
  'dashboard': React.lazy(() => import('../pages/DashboardPage')),
  'callbacks': React.lazy(() => import('../pages/CallBackRequestsPage')),
  'account-leads': React.lazy(() => import('../pages/AccountRequestsPage')),
  'enquiries': React.lazy(() => import('../pages/ContactEnquiriesPage')),
  'partnerships': React.lazy(() => import('../pages/FranchiseApplicationsPage')),
  'job-applications': React.lazy(() => import('../pages/JobSeekersPage')),
  'downloads-catalog': React.lazy(() => import('../pages/ManageDownloadsPage')),
  'research-reports': React.lazy(() => import('../pages/ResearchManagerPage')),
  'investor-disclosures': React.lazy(() => import('../pages/InvestorsManagerPage')),
  'statutory-certs': React.lazy(() => import('../pages/StatutoryDocumentsPage')),
  'announcements': React.lazy(() => import('../pages/MessageNotificationPage')),
  'testimonials': React.lazy(() => import('../pages/TestimonialsPage')),
  'website-popup': React.lazy(() => import('../pages/WebsitePopupPage')),
};

export default componentRegistry;
